import { render } from "./UnitInput.vue?vue&type=template&id=16e877bf&scoped=true"
import script from "./UnitInput.vue?vue&type=script&lang=js"
export * from "./UnitInput.vue?vue&type=script&lang=js"

import "./UnitInput.vue?vue&type=style&index=0&id=16e877bf&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e877bf"]])

export default __exports__